export const TOOLTIP_ROLE = 'tooltip';
export const TOOLTIP_DEFAULT_POSITION = 'bottom';
export const TOOLTIP_DEFAULT_SHOW_POPPER_ARROW = true;
export const TOOLTIP_DEFAULT_DELAY = 0;
export const TOOLTIP_DEFAULT_CONTENT = 'tooltip content';
export const POPPER_ARROW_TAB_INDEX = -1;
